<template>
  <div class="wrapper">
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/newmis36/util/url'
  import Qs from 'qs'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  let status = {"0":"未启用","1":"启用"};
  export default {
    name: 'list',
    components: {
      tablePage,
      UPDATE
    },
    mounted(){
        this.$refs.childTable.defaultGetData();
    },
    methods: {
        bthClick (clickName, row) {
            if (clickName == "update"){
                row.id = row.name;
                this.$refs.childUpdate.open(row);
            }
        },
        submit(model){
            //根据是否包含id更新还是添加
            this.dataChanage(URL.riskSWitch.edit,model,res => {
                if (res.code == 0){
                    this.$refs.childUpdate.close();
                    this.$message.success("suc");
                }else{
                    this.$message.error(res.message);
                }
            })
        },
        dataChanage(url,option,suc,fail){
            this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                this.$refs.childTable.defaultGetData();
                if(suc && (typeof suc == 'function')) suc(res);
            }).catch(res => {
                if(fail && (typeof fail == 'function')) fail(res);
            })
        }
    },
    data () {
      return {
        updateData:{
            cols: [
                { title: 'key', field: 'key',hidden:true},
                { title: window.$t('txmis.risk.name'), field: 'name',readonly:true},
                { title: window.$t('txmis.common.status'), field: 'status',type:2,optionList:status},
                { title: window.$t('txmis.common.remark'), field: 'remark'},
            ]
        },
        pageData: {
          isPage:false,
          queryUrl: URL.riskSWitch.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('txmis.risk.name'), field: 'name'},
              { title: window.$t('txmis.common.status'), field: 'status',render:(data)=>{
                  return status[data];
                  }},
              { title: window.$t('txmis.common.updater'), field: 'updateUser'},
              { title: window.$t('txmis.common.updateTime'), field: 'updateDate',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('txmis.common.remark'), field: 'remark'},
              {field:window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-update"},
          ]
        }
      }
    }
  }
</script>
